import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPayments } from "../../features/payment/paymentSlice";
import SideAndSearchbar from "../../Components/layouts/SideAndSearchbar";

const PaymentsList = () => {
  const dispatch = useDispatch();
  const { payments, loading, error } = useSelector((state) => state.payments);

  useEffect(() => {
    dispatch(fetchPayments());
  }, [dispatch]);

  return (
    <>
      <SideAndSearchbar />
      <div className="pcoded-main-container">
        <div className="container mt-4">
          <h2 className="text-center mb-4">Payment Transactions</h2>
          {loading && <p className="text-center">Loading payments...</p>}
          {error && <p className="text-danger text-center">Error: {error}</p>}

          <table className="table table-striped table-hover">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Payment ID</th>
                <th scope="col">Payment Type</th>
                <th scope="col">UPI ID</th>
                <th scope="col">Amount (₹)</th>
                <th scope="col">Status</th>
                <th scope="col">Created At</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr key={payment._id}>
                  <td>{payment.paymentId}</td>
                  <td>{payment.paymentType}</td>
                  <td>{payment.upiId || "N/A"}</td>
                  <td>₹{payment.amount}</td>
                  <td>
                    <span
                      className={`badge ${
                        payment.status === "Success"
                          ? "bg-success"
                          : payment.status === "Failed"
                          ? "bg-danger"
                          : "bg-warning"
                      }`}
                    >
                      {payment.status}
                    </span>
                  </td>
                  <td>{new Date(payment.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default PaymentsList;
